require('./dist/ng-sortable');
module.exports = 'as.sortable';



//////////////////
// WEBPACK FOOTER
// ./~/ng-sortable/index.js
// module id = 311
// module chunks = 0